var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightChevron9144319(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Guide"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-136-10h346v220h-346z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.5 31 15-15-15-15",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#111",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Line_Expand"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.5 32c-.26 0-.51-.1-.71-.29-.39-.39-.39-1.02 0-1.41l14.3-14.3-14.3-14.29c-.39-.39-.39-1.02 0-1.41s1.02-.39 1.41 0l15 15c.39.39.39 1.02 0 1.41l-15 15c-.19.19-.44.29-.7.29z",
    fill: "#111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightChevron9144319);
export default __webpack_public_path__ + "static/media/right-chevron_9144319.6e2c7d80905d8de98120279cfd8d8694.svg";
export { ForwardRef as ReactComponent };